<template>
  <div id="eqSetting">
    <div class="back">
      <div class="body">
        <div class="bodyback">
            <div class="c1" v-for="(item,index1) in drinks" :key="index1">
              <div v-for="(item2,index2) in item" :key="index2" style="height:190px">
                <div class="drinkback" :class="{noneback:!item2.cup,q1back:item2.cup&&item2.cupquantity==1,q2back:item2.cup&&item2.cupquantity==2,q3back:item2.cup&&item2.cupquantity==3}" >
                  <img v-if="item2.cup&&item2.cup.beverage&&item2.cup.beverage.picture" :src="$prefix+item2.cup.beverage.picture.path" class="dinkpic">
                  <img v-else-if="item2.cup!=null&&item2.cup.beverage.picture==null" src="@/assets/images/nopic.png" class="nopic">
                </div>
                  <div  class="cname" v-if="item2.cup&&item2.cup.beverage">{{item2.cup.beverage.name}}</div>
                  <div class="cname" v-if="item2.cup&&item2.cup.cupSize">{{item2.cup.cupSize.name}}</div>
                  <div   v-if="item2.cup" style="width:130px"><el-input v-if="item2.cup&&item2.cup.cupSize" size="small" v-model="item2.price" class="cnameyuan" id=percent name=percent           oninput="value=value.replace(/(^\.|[^\d\.])/g,''). replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^([^1])(\d)\d*/, '$1$2').replace(/^1\d{2,}.*/,'100')" />
                    <span style="font-size: 12px">{{$t('yuan')}}</span>
                  </div>
            </div>
          </div>

          <div style="text-align: center">
            <div @click="savePrice" style="display: inline-block;cursor: pointer;line-height: 40px;background-color: #805451;color: #fff;border-radius: 20px;padding: 0 20px">{{$t('save')}}</div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
export default {
  props:
    ['initvalue']
  ,
  name:"EquipmentButtomConfig",
  data() {
    return {
      allvisible:false,
      isFree:true,
      allpowder:[],
      selectedpowder:[],
      powderindex:-1,
      powderid:-1,
      drinks:[
        [{cupquantity:null,price:0,cup:null},{cupquantity:null,price:0,cup:null},{cupquantity:null,price:0,cup:null},{cupquantity:null,price:0,cup:null}],
        [{cupquantity:null,price:0,cup:null},{cupquantity:null,price:0,cup:null},{cupquantity:null,price:0,cup:null},{cupquantity:null,price:0,cup:null}],
        [{cupquantity:null,price:0,cup:null},{cupquantity:null,price:0,cup:null},{cupquantity:null,price:0,cup:null},{cupquantity:null,price:0,cup:null}],
        [{cupquantity:null,price:0,cup:null},{cupquantity:null,price:0,cup:null},{cupquantity:null,price:0,cup:null},{cupquantity:null,price:0,cup:null}]
      ],
      cupvisible:false,
      postData: {
        keyConfigPostDatas:[],
        equipment_ID:0
      },
      cupid:-1,
      cupquantity: 1,
      cupindex1:-1,
      cupindex2:-1,
      BtnConfigList:[],
      price:0,
      totalBtnConfigCount:0
    }
  },
  mounted() {
    Promise.all([this.init1()]).then(res=>{
      this.loadBtnConfigListQC();
    })

  },
  methods:{
    init1(){
      console.log(this.initvalue)
      return   this.$httpservice.get("api/Equipment/RawMaterials?equipmentId="+this.initvalue.id).then(res=>{
        this.allpowder = res.body.data
        //测试时默认展示前4个
        for(let i=0;i<res.body.data.length;i++){
          if(i<4){
            this.selectedpowder.push(res.body.data[i])
          }
        }
      })
    },

    //获取按键信息
    loadBtnConfigListQC(){
      let that = this;
      this.$httpservice.get("api/Equipment/KeyConfigs",{dtuNo:that.initvalue.dtuNumber}).then(
        (data) =>{
          if(data.body.code=="200"){
            that.BtnConfigList = data.body.data;
            let list =  that.BtnConfigList.filter(item=>{return item.cupType})
            if(list && list.length>0){
              for(let i in list){
                if(list[i].price>0){
                  that.isFree = false;
                }
                let sort = list[i].sort-1
                let index1 = sort%4
                let index2 = Math.floor(sort/4)
                //console.log(list[i])
                that.selectedpowder[index2] = list[i].cupType.beverage.rawMaterial
                that.drinks[index2][index1].cupquantity = 1;
                that.drinks[index2][index1].price = list[i].price;
                that.drinks[index2][index1].cup = list[i].cupType;
                that.$forceUpdate()

              }
            }

          }else{
            that.$message({
              message: data.body.msg,
              type: 'danger'
            });
          }
        },
        function (data) {
          let statusCode = data.status;
          that.$message({
            message: that.$t('queryFailedStatusCode')+statusCode,
            type: 'warning'
          });
        }
      );
    },
    //按键设置
    addBtnConfig(){
      if(this.postData !=null){
        let that = this;

        this.$httpservice.post("api/Equipment/AddKeyConfigs",that.postData).then(
          function (data) {
            if(data.body.code=="200"){
              that.$message({
                message: that.$t('equipmentmanagement.modifyPriceSuccessfully'),
                type: 'success'
              });
              that.loadBtnConfigListQC();
              }else{
                that.$message({
                  message: data.body.msg,
                  type: 'danger'
                });
              }
            },
            function (data) {
              let statusCode = data.status;
              that.$message({
                message: that.$t('queryFailedStatusCode')+statusCode,
                type: 'warning'
              });
            }
          );
        }else{
          this.$message({
            message: this.$t('equipmentmanagement.pleaseCompleteTheConfigurationInformation'),
            type: 'warning'
          });
      }
    },
    //保存配置
    savePrice(){
      this.postData.keyConfigPostDatas = []
        let arr = [];
        for(var i=0;i<this.drinks.length;i++){
          for(var j=0;j<this.drinks[i].length;j++){
            if(this.drinks[i][j].cup!=null){
              if(this.drinks[i][j].cup.beverage!=undefined){
                let dbprice = this.drinks[i][j].price*1;
                arr.push({"sort":i*4 + j+1,"cupType_ID":this.drinks[i][j].cup.id,"name":this.drinks[i][j].cup.beverage.name,"price":dbprice.toFixed(2)});
              }
            }

          }
        }
        console.log(arr);

        arr.forEach(e => {
          if(e.cupType_ID!= null){
            this.postData.keyConfigPostDatas.push({sort: e.sort,cupType_ID:e.cupType_ID,name:e.name,price:e.price});
            this.postData.equipment_ID = parseInt(this.initvalue.id);
          }
        })
        this.addBtnConfig();
    }
  }
}
</script>
<style scoped lang="less">
#eqSetting{
  .back{
    padding: 20px;
    background: url("../../assets/images/equipment/background_pay.jpg");
    background-size: 100% 100%;
    text-align: center;
  }

  .body{
    display: inline-block;
    width: 60%;
    input{
      .el-input__inner{
        text-align: center!important;
      }
    }
  }
  .headback{
    background: url("../../assets/images/equipment/back_material.jpg");
    background-size: 100% 100%;
    overflow: hidden;
    padding: 10px 0px;
  }
  .c1{
    float: left;
    width: 25%;
    text-align: center;
  }
  .c2{
    float: left;
    width: 20%;
    text-align: center;
    position: relative;
    margin-bottom: 20px;
  }

  .c1 img,.c2 img{
    width: 100px;
  }
  .cname{
    display: inline-block;
    width: 110px;
    line-height: 25px;
    color: #2e2115;
    background-size: 100% 100%;
    font-size: 12px;
  }
  .cnameyuan{
    margin-left: 25px;
    display: inline-block;
    width: 70px;
    font-size: 12px;
    height: 25px!important;
  }
  .powderlist{
    overflow: hidden;
    max-height: 500px;
    overflow-y: auto;
  }
  .checked{
    position: absolute;
    left: 20px;
    top: 0px;
    width: 20px!important;
    height: 20px!important;
  }
  .checked2{
    position: absolute;
    right: -10px;
    top: 5px;
    width: 20px!important;
    height: 20px!important;
  }
  .bodyback{
    padding: 20px 0;
    background-color: #f7ebe1;
    overflow: hidden;
  }

  .drinkback{
    width: 100px;
    height: 100px;
    /* margin-bottom: 20px; */
    display: inline-block;
    cursor: pointer;
  }
  .noneback{
    background-size: 100% 100%;
  }
  .q1back{
    background: url("../../assets/images/equipment/background_normal.png");
    background-size: 100% 100%;
  }
  .q2back{
    background: url("../../assets/images/equipment/background_bold.png");
    background-size: 100% 100%;
  }
  .q3back{
    background: url("../../assets/images/equipment/background_more_bold.png");
    background-size: 100% 100%;
  }
  .quantity{
    display: inline-block;
    line-height: 30px;
    vertical-align: top;
    margin-right: 20px;
    width: 60px;
    text-align: center;
    background-size: 100% 100% !important;
    color: #fff;
    cursor: pointer;
    position: relative;
  }
  .q1{
    background: url("../../assets/images/equipment/background_normal.png");
  }
  .q2{
    background: url("../../assets/images/equipment/background_bold.png");
  }
  .q3{
    background: url("../../assets/images/equipment/background_more_bold.png");
  }
  .dinkpic{
    display: inline-block;
    width: 80px!important;
    height: 80px!important;
    display: inline-block;
    margin-top: 10px;
  }

  .nopic{
    display: inline-block;
    width: 50px!important;
    height: 50px!important;
    display: inline-block;
    margin-top: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/equipmentPriceSetting.vue